export enum AiUsageType {
  Rewrote = "rewrote",
  Analysis = "analysis",
}

export enum AiTaskStatus {
  Extracting = 1,
  Success,
  Failed,
}

export enum ScriptStructureType {
  ProductDetails = "1",
  EfficiencyFeatures = "2",
  UserReview = "3",
  BuyNow = "4",
  AssignGroups = "5",
  UseGuides = "6",
  PreferentialActivities = "7",
}
